import useSwr from './useSwr';
export { default as useSWRInfinite } from './infinite'
export { mutate } from './resolve-args';

export default useSwr;
